import React from 'react';
import { Link } from 'react-router-dom';
import language from '../../../../utils/LanguageSettings';
import translations from '../../../../text/get-started-translations.json';
import { getLocalizedData } from '../../../functions/getLocalizedData';

const Categories: React.FC<{ categories: any[] }> = ({ categories }) => {
  const pageTranslations = translations[language];
  const showAllCategories = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.querySelectorAll<HTMLElement>(".side-sections li").forEach((item) => {
      item.classList.remove("hide");
    });
    const morelink = document.getElementsByClassName("more-link")[0] as HTMLElement;
    if (morelink) {
      morelink.style.display = "none";
    }
  };

  return (
    <div className="side-sections">
      <h3>{pageTranslations.Categories}</h3>
      <ul>
        <li key="最新文章_Latest Update"><Link to="/blog/filter/最新文章_Latest Update">{pageTranslations.LatestUpdate}</Link></li>
        {categories.map((category, index) => (
          <li key={category} className={index > 2 ? 'hide' : ''}><Link to={`/blog/filter/${category}`}>{getLocalizedData(category, language)}</Link></li>
        ))}
      </ul>
      {categories.length > 3 && <Link to="#" className="more-link" onClick={showAllCategories}>{pageTranslations.SeeAll}</Link>}
    </div>
  );
};

export default Categories;